import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import { computed, reactive } from 'vue';

interface State<T> {
    data: T;
    changed: boolean;
}

interface InternalState<T> extends State<T> {
    original: T;
}

type ChangeFn<T> = (newData: T) => void;
type Output<T> = { state: State<T>, change: ChangeFn<T>, reset: () => void };

export function useFormData<T>(data: T): Output<T> {
    const state = reactive<InternalState<T>>({
        data: cloneDeep(data),
        original: cloneDeep(data),
        changed: computed(() => !isEqual(state.original, state.data)),
    });

    const reset = (): void => {
        state.data = cloneDeep(state.original);
    };

    const change: ChangeFn<T> = (newData) => {
        state.original = cloneDeep(newData);
        state.data = cloneDeep(newData);
    };

    return { state, change, reset };
}
